import React, {Component} from 'react';
import Data from "./Data";
import $ from "jquery";
import axios from "axios";
import ModalEditClass from './ModalEditClass';

class InstrumentsList extends Component {

    constructor(props) {
        super(props);
        this.state={

        }
    }

    collapse(id){
        $('#'+id).collapse('toggle');
    }
    handleDelete(id,modalid,studentid){

        $('#'+modalid).modal('hide');
        $('#waitspinner').modal('show');

        let token = localStorage.getItem('token');
        let data = new FormData();
        data.append('token', '');
        data.append('id', id);
        axios.post(Data.server+`deleteInstrument.php`,data)
            .then(response => {
                $('#waitspinner').each(function (){
                    $(this).modal('hide');
                });
                if (response.data === 'ok') {
                    this.props.length();
                    this.props.toast("ساز با موفقیت حذف شد.","3000","bg-primary",()=> {
                        $('#'+studentid).addClass('animate__animated animate__fadeOut disabled');
                        $('#'+studentid).on('animationend',function (){
                            $(this).remove();
                        });

                        $('#liveToast').toast('show');
                    });
                }
                if (response.data === 'wrong id') {
                    this.props.toast("خطا : شناسه هنرجو اشتباه است","3000","bg-danger",()=> {

                        $('#liveToast').toast('show');
                    });
                }
                if (response.data.hasOwnProperty('no_item')) {
                    $('#no_item').removeClass('invisible');

                }
            })
            .catch(error => {
                console.log(error)
            });

    }

    render() {
        const {products,index} = this.props;
        let instrumentid = 'instrument'+index;
        let deletemodalid = 'deleteinstrument'+index;
        let editmodalid = 'editinstrument'+index;
        
        return (
            <tr id={instrumentid} key={index} className="text-center">

                <td>{products['name']}</td>
                <td>{products['mastername']}</td>
                <td>{products['type']=='0'?"معمولی":"گروه نوازی"}</td>
                <td><img className="" height="40px" width="40px" src={Data.server+"icons/"+products['icon']}/></td>
                <td><a href={Data.server+"images/"+products['masterpicture']} target="_blank">مشاهده عکس</a></td>
                <td>
                    <div className="btn-group" role="group" aria-label="Basic example">
                        <button type="button" className="btn btn-sm btn-outline-info" data-toggle="modal" data-target={"#"+editmodalid}>ویرایش</button>
                        <button type="button" className="btn btn-sm btn-outline-danger" data-toggle="modal" data-target={"#"+deletemodalid}>حذف</button>
                    </div>
                    {/* <ModalEditClass
                        toast={this.props.toast.bind(this)}
                        id={editmodalid}
                        instrumentid={products['id']}
                        products={products}
                        index={index} /> */}
                    
                    <div className="modal fade" id={deletemodalid} tabIndex="-1" aria-labelledby={deletemodalid+"Label"}
                         aria-hidden="true">
                        <div className="modal-dialog modal-dialog-scrollable modal-sm modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h6 className="modal-title" id={deletemodalid+"Label"}>{"حذف "+products['name']+" "+products['mastername']}</h6>
                                    <button type="button" className="close text-left ml-0" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {"آیا از حذف ساز "+products['name']+" با تدریس "+products['mastername']+ " مطمئن هستید ؟"}
                                    <br />
                                    <strong>{"با این کار تمام کلاس های مربوط به این ساز و استاد پاک خواهد شد"}</strong>
                                </div>
                                <div className="modal-footer">
                                    <div className="btn-group">
                                        <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={() => this.handleDelete(products['id'],deletemodalid,instrumentid)}>بله</button>
                                        <button type="button" className="btn btn-secondary" data-dismiss="modal">خیر</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </td>
            </tr>

        );
    }
}


export default InstrumentsList;
